/**
 * 섹션화된 요약 컴포넌트 (Issue #446 PR2-B)
 *
 * IonIcon → F7 Icon (framework7-icons). 시각/동작은 동일.
 */

import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import { Icon } from "framework7-react";
import {
  isSectionedSummary,
  parseSummaryLong,
  preprocessMarkdown,
} from "@tldr/utils";
import type { SummarySection } from "@tldr/utils";
import "./SectionedSummary.css";

interface SectionedSummaryProps {
  summaryLong: string;
  contentRaw?: string | null;
  onSectionTap?: (sectionId: string) => void;
}

const SectionedSummary: React.FC<SectionedSummaryProps> = ({
  summaryLong,
  contentRaw,
  onSectionTap,
}) => {
  if (!isSectionedSummary(summaryLong)) {
    return (
      <div className="sectioned-summary">
        <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
          {preprocessMarkdown(summaryLong)}
        </ReactMarkdown>
      </div>
    );
  }

  const sections: SummarySection[] = parseSummaryLong(summaryLong);
  const tappable = Boolean(contentRaw);

  return (
    <div className="sectioned-summary">
      {sections.map((section) => (
        <div
          key={section.id}
          className={`summary-section-item${tappable ? " tappable" : ""}`}
          onClick={
            tappable && onSectionTap
              ? () => onSectionTap(section.id)
              : undefined
          }
        >
          <div className="section-heading-row">
            <span className="section-heading">{section.heading}</span>
            {section.timestamp && (
              <span className="section-timestamp">{section.timestamp}</span>
            )}
            {tappable && (
              <Icon
                f7="chevron_right"
                className="section-arrow"
                aria-hidden="true"
              />
            )}
          </div>
          {section.body && (
            <div className="section-body">
              <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
                {preprocessMarkdown(section.body)}
              </ReactMarkdown>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SectionedSummary;
